// Structured data generators for SEO

export const generateOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "DayShift MMA",
  description: "UFC Fantasy League Platform",
  url: process.env.REACT_APP_SITE_URL || "https://dayshiftsports.com",
  logo: `${process.env.REACT_APP_SITE_URL || "https://dayshiftsports.com"}/logo-gold.png`,
  sameAs: [
    // Add your social media URLs here
    "https://twitter.com/DayShiftMMA",
    "https://facebook.com/DayShiftMMA",
  ],
});

export const generateWebApplicationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebApplication",
  name: "DayShift MMA",
  description:
    "UFC Fantasy League Platform - Create leagues, compete globally, and dominate the octagon",
  url: process.env.REACT_APP_SITE_URL || "https://dayshiftsports.com",
  applicationCategory: "GameApplication",
  operatingSystem: "Web Browser",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "USD",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.8",
    ratingCount: "1250",
  },
});

export const generateSportsEventSchema = (event) => {
  if (!event) return null;

  return {
    "@context": "https://schema.org",
    "@type": "SportsEvent",
    name: event.name || event.title,
    description: `UFC Event: ${event.name || event.title}`,
    startDate: event.date || event.startDate,
    location: {
      "@type": "Place",
      name: event.location || "UFC Arena",
    },
    sport: "Mixed Martial Arts",
    organizer: {
      "@type": "Organization",
      name: "UFC",
    },
  };
};

export const generateBreadcrumbSchema = (breadcrumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: crumb.name,
    item: `${process.env.REACT_APP_SITE_URL || "https://dayshiftsports.com"}${crumb.path}`,
  })),
});

export const generatePersonSchema = (user) => {
  if (!user) return null;

  return {
    "@context": "https://schema.org",
    "@type": "Person",
    name: user.username || user.name,
    image: user.profilePicture || user.picture,
    description: `DayShift MMA user profile for ${user.username || user.name}`,
  };
};

export const generateFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
});
